export const DataList = [
    {id:1, name:"Сегодня"},
    {id:2, name:"Текущая неделя"},
    {id:3, name:"Текущий месяц"},
    {id:4, name:"Текущий год"},
    {id:5, name:"Вчера"},
    {id:5, name:"Прошлая неделя"},
    {id:6, name:"Прошлый месяц"},
    {id:7, name:"Прошлый год"},
    {id:8, name:"Все время"}
  ];
  export const DataListViborka = [
    {id:1, name:"Дата создания"},
    {id:2, name:"Дата выполнения"},
  ];
  
  

  export const tableHeadIndicators = [
    { key: "number", value: "Номер заявки", isActive: true  },
    { key: "unit", value: "Подразделение", isActive: true  },
    { key: "object", value: "Объект", isActive: true  },
    { key: "contractor", value: "Исполнитель", isActive: true  },
    { key: "builder", value: "Подрядчик", isActive: true  },
    { key: "status", value: "Статус заявки", isActive: true  },
    { key: "problemDescription", value: "Описание проблемы", isActive: true  },
    { key: "fileName", value: "Фото/Видео проблемы", isActive: true  },
    { key: "urgency", value: "Срочность", isActive: true  },
    { key: "createdAt", value: "Дата создания заявки", isActive: true  },
    { key: "daysAtWork", value: "Дней в работе", isActive: true  },
    { key: "completeDate", value: "Дата выполнения (факт)", isActive: true  },
    { key: "repairPrice", value: "Бюджет ремонта", isActive: true  },
    { key: "comment", value: "Комментарий", isActive: true  },
    { key: "legalEntity", value: "Юр. Лицо", isActive: true  },
    { key: "itineraryOrder", value: "Порядок маршрута", isActive: true  },
    { key: "checkPhoto", value: "Фото чека", isActive: true  },
  ]; 
  
